import React, {
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    Link,
    useParams
} from 'react-router-dom';


// Redux
import {
    confirmarCuentaAction
} from '../../actions/confirmarCuentaActions';

import {
    solicitaNuevamenteAction
} from '../../actions/solicitaNuevamenteActions';

import {
    setearAlerta,
    ocultarAlertaAction
} from '../../actions/alertaActions';


// CSS
import {
    PaginaConfirmacion,
    HeaderConfirmacion,
    LogoLink,
    Logo,
    LinkLogin,

    ContenedorConfirmacion,
    PanelInformativo,
    EtiquetaPanel,
    TituloPanel,
    TextoPanel,
    IlustracionPanel,

    TarjetaConfirmacion,
    EncabezadoTarjeta,
    TituloTarjeta,
    TextoTarjeta,

    MensajeEstado,

    BloqueAccion,
    BotonPrincipal,

    Separador,

    BloqueReenvio,
    PreguntaReenvio,
    BotonTexto,

    FormularioReenvio,
    Campo,
    Label,
    Input,
    TextoError,

    AccionesReenvio,
    BotonSecundario,

    TextoLoginMobile
} from '../Css/StyledConfirmarCuenta';


/*
========================================
CONFIRMAR CUENTA
========================================
*/

const ConfirmarCuenta = () => {

    const {
        token
    } = useParams();


    const dispatch =
        useDispatch();


    /*
    ====================================
    ESTADO LOCAL
    ====================================
    */

    const [
        mostrarReenvio,
        setMostrarReenvio
    ] = useState(false);


    const [
        email,
        setEmail
    ] = useState('');


    /*
    ====================================
    REDUX
    ====================================
    */

    const cargando =
        useSelector(
            state =>
                state.usuario.loading
        );


    const error =
        useSelector(
            state =>
                state.usuario.error
        );


    const confirmado =
        useSelector(
            state =>
                state.usuario.confirmado
        );


    const reenviado =
        useSelector(
            state =>
                state.usuario.solicitarConfirmar
        );


    const alerta =
        useSelector(
            state =>
                state.alertas.alerta
        );


    /*
    ====================================
    CONFIRMAR CUENTA
    ====================================
    */

    const confirmarCuenta = () => {

        /*
        Conservamos el formato que ya
        utiliza tu action.
        */

        dispatch(
            confirmarCuentaAction({
                token
            })
        );

    };


    /*
    ====================================
    ABRIR REENVÍO
    ====================================
    */

    const abrirReenvio = () => {

        dispatch(
            ocultarAlertaAction()
        );


        setMostrarReenvio(
            true
        );

    };


    /*
    ====================================
    CANCELAR REENVÍO
    ====================================
    */

    const cancelarReenvio = () => {

        dispatch(
            ocultarAlertaAction()
        );


        setEmail(
            ''
        );


        setMostrarReenvio(
            false
        );

    };


    /*
    ====================================
    SOLICITAR NUEVO ENLACE
    ====================================
    */

    const solicitarNuevoToken = (
        e
    ) => {

        e.preventDefault();


        const emailLimpio =
            email
                .trim()
                .toLowerCase();


        if (
            !emailLimpio
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Ingresá el email de tu cuenta'
                })
            );


            return;

        }


        const emailValido =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                .test(
                    emailLimpio
                );


        if (
            !emailValido
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Ingresá un email válido'
                })
            );


            return;

        }


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            solicitaNuevamenteAction({

                payload: {

                    email:
                        emailLimpio

                }

            })
        );

    };


    /*
    ====================================
    MENSAJES
    ====================================
    */

    const mensajeError =

        typeof error ===
        'string'

            ?
            error

            :
            error?.msg ||
            '';


    const mensajeConfirmado =

        typeof confirmado ===
        'string'

            ?
            confirmado

            :
            confirmado?.msg ||
            '';


    const mensajeReenviado =

        typeof reenviado ===
        'string'

            ?
            reenviado

            :
            reenviado?.msg ||
            '';


    return (

        <PaginaConfirmacion>


            {/* =========================
                HEADER
            ========================== */}

            <HeaderConfirmacion>


                <LogoLink
                    as={Link}
                    to="/"
                >

                    <Logo
                        src="/img/metodoYogenLogo_recortado.png"
                        alt="Método YÖGEN"
                    />

                </LogoLink>


                <LinkLogin
                    as={Link}
                    to="/login"
                >

                    Iniciar sesión

                </LinkLogin>


            </HeaderConfirmacion>


            {/* =========================
                CONTENIDO
            ========================== */}

            <ContenedorConfirmacion>


                {/* =====================
                    PANEL
                ====================== */}

                <PanelInformativo>


                    <EtiquetaPanel>
                        MÉTODO YÖGEN
                    </EtiquetaPanel>


                    <TituloPanel>

                        Un último paso

                    </TituloPanel>


                    <TextoPanel>

                        Confirmá tu dirección de correo
                        electrónico para activar tu cuenta
                        y comenzar a utilizar la plataforma.

                    </TextoPanel>


                    <IlustracionPanel
                        src="/img/ilustracionConfirmarCuenta.png"
                        alt=""
                    />


                </PanelInformativo>


                {/* =====================
                    TARJETA
                ====================== */}

                <TarjetaConfirmacion>


                    <EncabezadoTarjeta>


                        <TituloTarjeta>

                            Confirmar cuenta

                        </TituloTarjeta>


                        <TextoTarjeta>

                            Tocá el botón para validar
                            tu cuenta de Método YÖGEN.

                        </TextoTarjeta>


                    </EncabezadoTarjeta>


                    {/* =====================
                        ESTADOS
                    ====================== */}

                    {
                        cargando && (

                            <MensajeEstado>

                                Procesando solicitud...

                            </MensajeEstado>

                        )
                    }


                    {
                        mensajeError && (

                            <MensajeEstado $error>

                                {
                                    mensajeError
                                }

                            </MensajeEstado>

                        )
                    }


                    {
                        mensajeConfirmado && (

                            <MensajeEstado $exito>

                                {
                                    mensajeConfirmado
                                }

                            </MensajeEstado>

                        )
                    }


                    {
                        mensajeReenviado && (

                            <MensajeEstado $exito>

                                {
                                    mensajeReenviado
                                }

                            </MensajeEstado>

                        )
                    }


                    {
                        alerta?.msg && (

                            <MensajeEstado $error>

                                {
                                    alerta.msg
                                }

                            </MensajeEstado>

                        )
                    }


                    {/* =====================
                        CONFIRMAR
                    ====================== */}

                    <BloqueAccion>


                        <BotonPrincipal

                            type="button"

                            onClick={
                                confirmarCuenta
                            }

                            disabled={
                                cargando
                            }

                        >

                            {
                                cargando
                                    ?
                                    'Confirmando...'
                                    :
                                    'Confirmar cuenta'
                            }

                        </BotonPrincipal>


                    </BloqueAccion>


                    <Separador />


                    {/* =====================
                        REENVIAR
                    ====================== */}

                    <BloqueReenvio>


                        {
                            !mostrarReenvio
                                ?
                                (

                                    <>
                                        <PreguntaReenvio>

                                            ¿El enlace venció o
                                            no recibiste el correo?

                                        </PreguntaReenvio>


                                        <BotonTexto

                                            type="button"

                                            onClick={
                                                abrirReenvio
                                            }

                                        >

                                            Solicitar un nuevo enlace

                                        </BotonTexto>
                                    </>

                                )
                                :
                                (

                                    <FormularioReenvio
                                        onSubmit={
                                            solicitarNuevoToken
                                        }
                                        noValidate
                                    >


                                        <Campo>


                                            <Label
                                                htmlFor="email"
                                            >

                                                Email de tu cuenta

                                            </Label>


                                            <Input

                                                id="email"

                                                name="email"

                                                type="email"

                                                autoComplete="email"

                                                placeholder="nombre@email.com"

                                                value={
                                                    email
                                                }

                                                disabled={
                                                    cargando
                                                }

                                                onChange={
                                                    e => {

                                                        setEmail(
                                                            e.target.value
                                                        );


                                                        if (
                                                            alerta
                                                        ) {

                                                            dispatch(
                                                                ocultarAlertaAction()
                                                            );

                                                        }

                                                    }
                                                }

                                            />


                                            {
                                                alerta?.msg && (

                                                    <TextoError>

                                                        {
                                                            alerta.msg
                                                        }

                                                    </TextoError>

                                                )
                                            }


                                        </Campo>


                                        <AccionesReenvio>


                                            <BotonSecundario

                                                type="button"

                                                onClick={
                                                    cancelarReenvio
                                                }

                                                disabled={
                                                    cargando
                                                }

                                            >

                                                Cancelar

                                            </BotonSecundario>


                                            <BotonPrincipal

                                                type="submit"

                                                disabled={
                                                    cargando
                                                }

                                            >

                                                {
                                                    cargando
                                                        ?
                                                        'Enviando...'
                                                        :
                                                        'Enviar nuevo enlace'
                                                }

                                            </BotonPrincipal>


                                        </AccionesReenvio>


                                    </FormularioReenvio>

                                )
                        }


                    </BloqueReenvio>


                    <TextoLoginMobile>

                        ¿Ya confirmaste tu cuenta?{' '}

                        <Link to="/login">
                            Iniciá sesión
                        </Link>

                    </TextoLoginMobile>


                </TarjetaConfirmacion>


            </ContenedorConfirmacion>


        </PaginaConfirmacion>

    );

};


export default ConfirmarCuenta;